if (typeof window !== 'undefined') {
  /* eslint-disable-next-line global-require */
  require('smoothscroll-polyfill').polyfill();
}
